export const ExternalContactType = {
  BORROWER: 'Borrower',
  COBORROWER: 'CoBorrower',
  LOAN_OFFICER: 'LoanOfficer',
  REALTOR: 'Realtor',
  TITLE_HOLDER: 'TitleHolder',
  NON_BORROWING: 'NonBorrowing',
  LISTING_AGENT: 'ListingAgent',
  SELLING_AGENT: 'SellingAgent',
  TITLE_COMPANY: 'TitleCompany',
  ESCROW_COMPANY: 'EscrowCompany',
  SELLER: 'Seller',
  CLOSER: 'Closer',
};

const commonContactsTitles = {
  [ExternalContactType.BORROWER]: 'Borrower',
  [ExternalContactType.COBORROWER]: 'Co-Borrower',
  [ExternalContactType.LOAN_OFFICER]: 'Loan Officer',
  [ExternalContactType.REALTOR]: 'Realtor',
};

export const borrowerContactType = [ExternalContactType.BORROWER, ExternalContactType.COBORROWER];

export const loanSummaryIgnoreList = [
  ExternalContactType.TITLE_COMPANY,
  ExternalContactType.ESCROW_COMPANY,
];

export const loanSummaryContactsTitles = {
  ...commonContactsTitles,
  [ExternalContactType.TITLE_HOLDER]: 'Title Holder',
  [ExternalContactType.NON_BORROWING]: 'NBE',
  [ExternalContactType.LISTING_AGENT]: 'Listing Agent',
  [ExternalContactType.SELLING_AGENT]: 'Selling Agent',
  [ExternalContactType.SELLER]: 'Seller',
  [ExternalContactType.CLOSER]: 'Closer',
};

export const ExternalContactsTitles = {
  ...commonContactsTitles,
  [ExternalContactType.TITLE_HOLDER]: 'Additional contact, Title Holder',
  [ExternalContactType.NON_BORROWING]: 'Additional contact, Non-Borrowing Entity',
  [ExternalContactType.LISTING_AGENT]: 'Additional contact, Listing Agent',
  [ExternalContactType.SELLING_AGENT]: 'Additional contact, Selling Agent',
  [ExternalContactType.TITLE_COMPANY]: 'Additional contact, Title Company',
  [ExternalContactType.ESCROW_COMPANY]: 'Additional contact, Escrow Company',
  [ExternalContactType.SELLER]: 'Additional contact, Seller',
  [ExternalContactType.CLOSER]: 'Additional contact, Closer',
};
